import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	root: {
		display: 'flex',
		flexWrap: 'wrap'
	},
	buttonContainer: {
		/* MarginBottom: theme.spacing(1) + 1,
        [theme.breakpoints.down('sm')]: {
            marginBottom: 0,
        }, */
		padding: theme.spacing(1)
	},
	dialogTitle: {
		padding: `${theme.spacing(2)}px ${theme.spacing(2)}px 
                  0px ${theme.spacing(3)}px`
	},
	gridList: {
		width: '100%',
		marginTop: theme.spacing(2)
	},
	gridListTile: {
		minWidth: 240,
		marginTop: theme.spacing(3)
	},
	listItem: {
		padding: 0,
		paddingRight: theme.spacing(1)
	},
	listItemIcon: {
		minWidth: 0
	}
}));
